// extracted by mini-css-extract-plugin
module.exports = {"listItem":"listItem__OoBHJ","name":"name__GUjBq","badge":"badge__QrcnD"};